/* GENERADO por scripts/shopify-theme/make-src.js desde assets/js/stats.js: no editar a mano. Manda al panel /stats de extracm.com. */
/* ExtraCM — medición propia (panel /stats). Sin dependencias, < 4 KB gzip.
   · Sesión: sessionStorage + cookie de 30 min (la cookie solo fuera de UE/UK o con consentimiento).
   · Visitante: cookie de 13 meses, solo fuera de UE/UK o con consentimiento.
   · Envía lotes a /api/t con sendBeacon (nunca bloquea; si falla, no pasa nada).
   · Las páginas registran eventos con  (window.ecmq = window.ecmq || []).push(['nombre', {props}])
     y leen la sesión con  window.ecmStats.sid()  para el permalink del checkout.
   · Tráfico propio: /?internal=1 pone la cookie extracm_internal un año; ?audit=1 marca solo esa visita.
   · Nunca guarda datos personales. Ver scripts/stats/README.md. */
(function () {
  'use strict';
  if (window.ecmStats) return;
  var EP = 'https://extracm.com/api/t', SS = 'extracm_sid', VC = 'extracm_vid', IC = 'extracm_internal';
  var MKTS = 'au cl co cs de el es fr it mx nl nz pa pe pl pt us uy ie ca';
  var loc = location, path = loc.pathname.replace(/\/index\.html$/, '').replace(/\/+$/, '') || '/';
  var qs = loc.search, sp;
  try { sp = new URLSearchParams(qs); } catch (e) { sp = { get: function () { return null; } }; }

  function cookie(n) { var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function setCookie(n, v, sec) { document.cookie = n + '=' + encodeURIComponent(v) + '; Path=/; Max-Age=' + sec + '; SameSite=Lax' + (loc.protocol === 'https:' ? '; Secure' : ''); }
  function rid(n) {
    var s = '', a = new Uint8Array(n);
    try { crypto.getRandomValues(a); } catch (e) { for (var i = 0; i < n; i++) a[i] = Math.random() * 256; }
    for (var j = 0; j < n; j++) s += (a[j] % 36).toString(36);
    return s;
  }
  function inEurope() {
    try { var tz = (Intl.DateTimeFormat().resolvedOptions().timeZone || ''); return tz.indexOf('Europe/') === 0 || ['Atlantic/Canary', 'Atlantic/Madeira', 'Atlantic/Azores', 'Atlantic/Reykjavik'].indexOf(tz) !== -1; } catch (e) { return true; }
  }

  // ---- consentimiento (misma lógica que consent.js; __ecmConsentGranted la expone consent.js) ----
  var stored = ''; try { stored = localStorage.getItem('extracm_consent') || ''; } catch (e) {}
  var consent = stored === 'granted' || stored === 'denied' ? stored : 'na';
  var eu = inEurope();
  var persist = window.__ecmConsentGranted === true || (!eu) || consent === 'granted';

  // ---- interno / auditoría ----
  if (sp.get('internal') === '1') setCookie(IC, '1', 31536000);
  var internal = cookie(IC) === '1' || sp.get('audit') === '1';

  // ---- sesión y visitante ----
  var sid = ''; try { sid = sessionStorage.getItem(SS) || ''; } catch (e) {}
  if (!sid && persist) sid = cookie(SS);
  if (!/^[a-z0-9]{6,16}$/.test(sid)) sid = rid(10);
  try { sessionStorage.setItem(SS, sid); } catch (e) {}
  function touch() { if (persist) setCookie(SS, sid, 1800); }
  touch();
  var vid = '';
  if (persist) { vid = cookie(VC); if (!/^[a-z0-9]{6,16}$/.test(vid)) vid = rid(12); setCookie(VC, vid, 34128000); }

  // ---- contexto de la página ----
  // En Shopify el mercado y la página los declara el layout (window.ECM_MKT / ECM_PAGE)
  var mkt = String(window.ECM_MKT || '');
  var pgt = window.ECM_PAGE === 'buy' ? 'buy' : (window.ECM_PAGE === 'home' ? 'home' : 'other');
  // La versión sale de la propia página: la declara <meta name="ecm-ab"> (la pone build_b.py).
  // Hasta el 27-sep se deducía de un <script> que solo llevaba la B; ese script pasó a estar
  // en las dos versiones, así que ahora va por la marca explícita. La cookie es el respaldo.
  var abCookie = cookie('extracm_ab'), ab = '';
  if (pgt === 'buy') {
    var mark = document.querySelector('meta[name="ecm-ab"]');
    var mv = mark && mark.getAttribute('content');
    ab = /^[AB]$/.test(mv) ? mv : (/^[AB]$/.test(abCookie) ? abCookie : (/\/buy-b(\/|$)/.test(path) ? 'B' : 'A'));
  }
  var forced = sp.get('ab'); var abf = pgt === 'buy' && (forced === 'A' || forced === 'B');
  var dev = (navigator.userAgentData && navigator.userAgentData.mobile) || /Mobi|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : (/iPad|Tablet/i.test(navigator.userAgent) ? 'tablet' : 'desktop');
  var ref = ''; try { var r = document.referrer && new URL(document.referrer); if (r && r.hostname !== loc.hostname && !/(^|\.)extracm\.com$/.test(r.hostname)) ref = r.hostname.replace(/^www\./, ''); } catch (e) {}
  var cid = sp.get('fbclid') ? 'fbclid' : sp.get('ttclid') ? 'ttclid' : sp.get('gclid') ? 'gclid' : '';
  var utm = {}; ['source', 'medium', 'campaign', 'content'].forEach(function (k) { var v = sp.get('utm_' + k); if (v) utm[k] = v.slice(0, 120); });
  // La atribución de la sesión se guarda para que las páginas siguientes (sin ?utm) la conserven.
  try {
    var att = JSON.parse(sessionStorage.getItem('extracm_att') || 'null');
    if (utm.source || ref || cid) { att = { u: utm, r: ref, c: cid }; sessionStorage.setItem('extracm_att', JSON.stringify(att)); }
    else if (att) { utm = att.u || {}; ref = att.r || ''; cid = att.c || ''; }
  } catch (e) {}

  // ---- cola y envío ----
  var queue = [], timer = null, wd = !!navigator.webdriver, sent = 0;
  function envelope() {
    var b = { v: 1, sid: sid, page: path, pgt: pgt, mkt: mkt, lang: (document.documentElement.lang || '').toLowerCase(), dev: dev, consent: consent, b: rid(12), e: queue };
    if (vid) b.vid = vid; if (ab) b.ab = ab; if (abf) b.abf = 1; if (ref) b.ref = ref; if (cid) b.cid = cid;
    if (utm.source) b.us = utm.source; if (utm.medium) b.um = utm.medium; if (utm.campaign) b.uc = utm.campaign; if (utm.content) b.ut = utm.content;
    if (internal) b.internal = 1; if (wd) b.wd = 1;
    return b;
  }
  function flush() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (!queue.length) return;
    var body = JSON.stringify(envelope()); queue = []; sent++;
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(EP, new Blob([body], { type: 'text/plain' }))) return;
    } catch (e) {}
    try { fetch(EP, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {}); } catch (e) {}
  }
  function track(name, props) {
    if (typeof name !== 'string' || !/^[a-z][a-z0-9_]{1,31}$/.test(name)) return;
    var ev = { n: name, t: Date.now() };
    if (props && typeof props === 'object') ev.p = props;
    queue.push(ev); touch();
    // El primer lote sale a los 400 ms (los rebotes rapidos no siempre disparan pagehide); los siguientes cada 2 s.
    if (queue.length >= 10) flush(); else if (!timer) timer = setTimeout(flush, sent ? 2000 : 400);
  }

  // ---- API pública + cola previa ----
  var pre = window.ecmq || [];
  window.ecmq = { push: function (a) { track(a[0], a[1]); } };
  window.ecmStats = { track: track, flush: flush, sid: function () { return sid; }, vid: function () { return vid; }, ab: ab, mkt: mkt, internal: internal };
  for (var i = 0; i < pre.length; i++) { try { track(pre[i][0], pre[i][1]); } catch (e) {} }

  // ---- eventos automáticos ----
  track('page_view');
  if (pgt === 'buy') track('pdp_view', { variant: ab || 'A' });
  addEventListener('pageshow', function (e) { if (e.persisted) track('page_view', { bf: 1 }); });
  addEventListener('pagehide', flush);
  document.addEventListener('visibilitychange', function () { if (document.hidden) flush(); });
  addEventListener('error', function (e) { try { track('error', { msg: String(e.message || '').slice(0, 200), src: String(e.filename || '').split('/').pop().slice(0, 60) }); } catch (x) {} });
  document.addEventListener('play', function (e) { var v = e.target; if (v && v.tagName === 'VIDEO' && !v.__ecm) { v.__ecm = 1; track('video_play', { id: (v.id || v.currentSrc || '').split('/').pop().slice(0, 60) }); } }, true);
  document.addEventListener('toggle', function (e) { var d = e.target; if (d && d.tagName === 'DETAILS' && d.open) { var faq = d.className.indexOf('faq') !== -1; track(faq ? 'faq_open' : 'accordion_open', { q: (d.querySelector('summary') || d).textContent.trim().slice(0, 80) }); } }, true);
  if (pgt === 'buy') {
    var marks = [25, 50, 75, 100], seen = {};
    function onScroll() {
      var h = document.documentElement, pct = Math.round((h.scrollTop + innerHeight) / h.scrollHeight * 100);
      for (var k = 0; k < marks.length; k++) if (pct >= marks[k] && !seen[marks[k]]) { seen[marks[k]] = 1; track('scroll', { pct: marks[k] }); }
      if (seen[100]) removeEventListener('scroll', onScroll);
    }
    addEventListener('scroll', onScroll, { passive: true });
  }
})();
